import styles from '../../styles/Lightbox.module.scss';

const LightBox = ({
  type, // 'image' | 'video'
  url,
  name,
  onClose,
  onSelect,
  displaySelect = true,
}) => {
  return (
    <div className={styles.lightboxBackdrop}>
      <div className={styles.lightbox}>
        {type === 'image' ? <img src={url} alt={name} /> : <video src={url} controls />}
        <div className={styles.lbMeta}>
          <div className={styles.lbName}>{name}</div>
          {displaySelect && (
            <button onClick={onSelect} className="shake__btnPrimary">
              Use this {type}
            </button>
          )}
          <button onClick={onClose} className="shake__btnGhost">
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default LightBox;
